import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { REM_CONFIG } from "@/utils/fontSize";
const ProcessingPlan = ({ className = "", data, }) => {
    // 模拟默认数据（确保4个单位）
    const defaultData = [
        {
            unitId: "01",
            unitName: "新疆化工",
            monthProcess: 11000,
            yearPlan: 14000,
            yearAccumulate: 18000,
            completeRate: 0.5,
        },
        {
            unitId: "02",
            unitName: "包头化工",
            monthProcess: 10000,
            yearPlan: 13000,
            yearAccumulate: 16000,
            completeRate: 0.65,
        },
        {
            unitId: "03",
            unitName: "榆林化工",
            monthProcess: 5000,
            yearPlan: 12000,
            yearAccumulate: 16000,
            completeRate: 0.45,
        },
        {
            unitId: "04",
            unitName: "神木化工",
            monthProcess: 11000,
            yearPlan: 14000,
            yearAccumulate: 15000,
            completeRate: 0.8,
        },
    ];
    const dataSource = data || defaultData;
    // 计算金额最大值（用于自适应Y轴）
    const allAmountData = [
        ...dataSource.map((item) => item.monthProcess),
        ...dataSource.map((item) => item.yearPlan),
        ...dataSource.map((item) => item.yearAccumulate),
    ];
    const maxAmount = Math.max(...allAmountData);
    // 计算合适的间隔
    const calculateInterval = (maxValue) => {
        if (maxValue <= 0)
            return 1;
        const magnitude = Math.pow(10, Math.floor(Math.log10(maxValue)));
        if (maxValue / magnitude <= 2)
            return magnitude / 2;
        if (maxValue / magnitude <= 5)
            return magnitude;
        return magnitude * 2;
    };
    const amountInterval = calculateInterval(maxAmount);
    // ECharts 配置项
    const option = {
        color: ["#ffc800", "#00d8ff", "#4080ff"],
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "cross" },
            backgroundColor: "rgba(10, 25, 55, 0.8)",
            borderColor: "rgba(0, 184, 255, 0.3)",
            textStyle: { color: "#fff" },
        },
        grid: {
            left: "4%", // 增大左侧间距，让柱子更分散
            right: "4%", // 增大右侧间距
            bottom: "2%",
            top: 60,
            containLabel: true,
        },
        legend: {
            right: "center",
            top: "4%",
            orient: "horizontal", // 显式设置水平排列
            itemGap: 10, // 调整项目间距，避免过挤
            width: "100%", // 限制图例宽度，避免超出容器
            itemHeight: 4, // 修改图标高度
            itemWidth: 8, // 修改图标宽度
            data: ["本月加工", "本年计划", "本年累计", "累计完成率"],
            textStyle: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small },
        },
        xAxis: {
            type: "category",
            data: dataSource.map((item) => item.unitName),
            axisLabel: {
                color: "#FFFFFF",
                fontSize: REM_CONFIG.fontSize.small,
                rotate: 0, // 文字水平显示
                interval: 0, // 强制显示所有标签
                margin: 14,
                overflow: "none",
            },
            axisLine: {
                lineStyle: { color: "rgba(255,255,255,0.3)" },
            },
            axisTick: { show: false },
        },
        yAxis: [
            {
                type: "value",
                name: "金额（万元）",
                nameTextStyle: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small },
                min: 0,
                // max: maxAmount > 0 ? maxAmount * 1.2 : undefined,
                // interval: amountInterval,
                axisLabel: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small },
                axisLine: {
                    lineStyle: { color: "rgba(255,255,255,0.3)" },
                },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" },
                },
                axisTick: { show: false },
            },
            {
                type: "value",
                name: "",
                nameTextStyle: { color: "#FFFFFF" },
                min: 0,
                max: 100,
                axisLabel: {
                    color: "#FFFFFF",
                    fontSize: REM_CONFIG.fontSize.small,
                    formatter: "{value}%",
                },
                axisLine: {
                    lineStyle: { color: "rgba(255,255,255,0.3)" },
                },
                splitLine: { show: false },
                axisTick: { show: false },
            },
        ],
        series: [
            {
                name: "本月加工",
                type: "bar",
                data: dataSource.map((item) => item.monthProcess),
                barWidth: 14, // 减小柱子宽度，增加间距
                itemStyle: {
                    borderRadius: [7, 7, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#FFF6DD" },
                        { offset: 1, color: "#FFC105" },
                    ]),
                },
            },
            {
                name: "本年计划",
                type: "bar",
                data: dataSource.map((item) => item.yearPlan),
                barWidth: 14,
                itemStyle: {
                    borderRadius: [7, 7, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#B3FFFF" },
                        { offset: 1, color: "#03FFFF" },
                    ]),
                },
            },
            {
                name: "本年累计",
                type: "bar",
                data: dataSource.map((item) => item.yearAccumulate),
                barWidth: 14,
                itemStyle: {
                    borderRadius: [7, 7, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#1097F8" },
                        { offset: 1, color: "#1A6DA9" },
                    ]),
                },
            },
            {
                name: "累计完成率",
                type: "line",
                yAxisIndex: 1,
                data: dataSource.map((item) => item.completeRate * 100),
                itemStyle: { color: "#00d8ff" },
                lineStyle: { color: "#00d8ff", width: 2 },
                symbol: "circle",
                symbolSize: 8,
            },
        ],
    };
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex flex-col 
        min-h-0
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u52A0\u5DE5\u8BA1\u5212" }), _jsx("div", { className: "flex-1 min-h-0", children: _jsx(ReactEcharts, { option: option, style: { width: "100%", height: "100%" } }) })] }));
};
export default ProcessingPlan;
